<template>
	<div class="form-group custom-control custom-checkbox" :class="{ 'has-error': hasError }">
		<label class="checkbox" @click="(e) => !disabled ? toggle(e) : null" :for="id">
			<input
			v-model="checkedState"
			type="checkbox"
			class="checkbox custom-control-input"
			:class="{
				'disabled': disabled
			}"
			:id="id"
			:name="name"
			:disabled="disabled"/>

			<span :class="`input-check ${checkedState ? '' : 'un'}checked`"></span>
			<span class="checkbox-label">
				{{ labelText }}
			</span>
		</label>

		<p v-if="hasError && inlineErrorText !==''" class="help-block">
			{{ inlineErrorText }}
		</p>
    </div>
</template>

<script>
export default {
	name: 'formCheckbox',
	introduction: 'VueJs checkbox component',
	model: {
		prop: 'checked',
		event: 'change'
	},
	props: {
		id: {
			type: String,
			default: '',
			note: 'Assign id'
		},
		name: {
			type: String,
			default: '',
			note: 'Set attribute name'

		},
		labelText: {
			type: String,
			default: '',
			note: 'Checkbox label text'
		},
		disabled: {
			type: Boolean,
			default: false,
			note: 'Disabled state, default false'
		},
		hasError: {
			type: Boolean,
			default: false,
			note: 'Show error when it need'
		},
		inlineErrorText: {
			type: String,
			default: '',
			note: 'when hasError true, you can assign inline error text'
		},
		checked: {
			type: Boolean,
			default: false,
			note: 'Default fasle'
		}
	},
	data() {
		return {
			checkedState: this.checked
		};
	},
	methods: {
		toggle(event) {
			this.checkedState = !this.checkedState;
			this.$emit('change', this.checkedState);
			event.stopPropagation();
			event.preventDefault();
		},
	},
	watch: {
		checked(newValue) {
			this.checkedState = newValue;
		}
	}
};
</script>

<style lang="less" scoped>
	label {
		font-size: 12px;
	}
</style>
